import Vue from "vue";
import "@/plugins/frontendRoles";
export default [
  {
    path: "/solicitudes",
    component: () =>
      import(/* webpackChunkName: "solicitudesList" */ "./layout.vue"),
    children: [
      //! ============================Listado de solicitudes============================
      {
        path: "/",
        name: "lista-solicitudes",
        meta: { rol: Vue.prototype.listRoles.solicitudes.lista },
        component: () =>
          import(
            /* webpackChunkName: "solicitudesList" */ "./views/ListaSolicitudes.vue"
          ),
      },
      // Seguimiento de solicitudes
      {
        path: "seguimiento",
        name: "solicitud-contratacion-seguimiento",
        component: () =>
          import("./views/list_aprobacion/pages/ListadoSolicitudesView.vue"),
      },
      //! ===========Crear/Editar/Ver de solicitudes de la unidad solicitante.===========
      {
        path: "solicitud",
        name: "solicitud-created",
        meta: { rol: Vue.prototype.listRoles.solicitudes.crear },
        component: () =>
          import(
            /* webpackChunkName: "solicitud" */ "./views/solicitud/page/Solicitud.vue"
          ),
      },
      {
        path: "solicitud/:id?/:firstOne?",
        name: "solicitud-update",
        meta: {
          isSolventar: true,
          rol: Vue.prototype.listRoles.solicitudes.editar,
        },
        component: () =>
          import(
            /* webpackChunkName: "solicitud" */ "./views/solicitud/page/Solicitud.vue"
          ),
      },
      {
        path: "solicitud-ver/:id",
        name: "solicitud-view",
        meta: { isView: true, rol: Vue.prototype.listRoles.solicitudes.ver },
        component: () =>
          import(
            /* webpackChunkName: "solicitud" */ "./views/solicitud/page/Solicitud.vue"
          ),
      },
      //!========================== Redirección de tabs de RRHH ===========================
      {
        path: "solicitud/visto-bueno/:id",
        name: "solicitud-visto-bueno",
        meta: { isView: true, rol: Vue.prototype.listRoles.solicitudes.ver },
        component: () =>
          import(
            /* webpackChunkName: "solicitud" */ "./views/solicitud/page/VistoBueno.vue"
          ),
      },
      //! ================================ Aprobaciones.===================================
      {
        path: "aprobacion/:id",
        name: "aprobacion-solicitud",
        component: () => import("./views/solicitud/aprobacion/pages/RRHH.vue"),
      },
      //Esta ruta solamente es para ver el componente del formulario contratacion-nombramiento
      {
        path: "/detalle/:id",
        name: "contrato-detalle",
        component: () =>
          import(
            /* webpackChunkName: "login" */ "../solicitudes/views/list_aprobacion/components/contratacion-nombramiento/FormularioContratacionNombramiento.vue"
          ),
      },
      {
        path: "nombramiento/:id_nombramiento",
        name: "solicitud-nombramiento-view",
        meta: {
          rol: Vue.prototype.listRoles.nombramiento.editar,
        },
        component: () =>
          import(
            /* webpackChunkName: "solicitudNombramiento" */ "./views/nombramiento/pages/Nombramiento.vue"
          ),
      },
    ],
  },
  {
    path: "/solicitudes-plaza-vacante",
    name: "solicitud-plaza-vacante",
    meta: {
      rol: Vue.prototype.listRoles.solicitudes.lista,
      plaza_vacante: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "solicitudesList" */ "./views/ListaSolicitudes.vue"
      ),
  },
  {
    path: "/solicitudes-contratacion-directa",
    name: "solicitud-contratacion-directa",
    meta: {
      //rol: Vue.prototype.listRoles.solicitudes.lista,
      contratacion_directa: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "solicitudesList" */ "./views/solicitud/component/contratacion-directa-v2/ListadoSolicitudContratacionDirecta.vue"
      ),
  },
  {
    path: "/solicitudes-contratacion-directa/formulario",
    name: "solicitud-contratacion-directa-formulario",
    component: () =>
      import(
        /* webpackChunkName: "SolicitudContratacionDirecta" */ "./views/solicitud/component/contratacion-directa-v2/SolicitudContratacionDirecta.vue"
      ),
  },
  {
    path: "/solicitudes-contratacion-directa/detalle/:id",
    name: "solicitud-contratacion-directa-detalle",
    component: () =>
      import(
        /* webpackChunkName: "SolicitudContratacionDirecta" */ "./views/solicitud/component/contratacion-directa-v2/SolicitudContratacionDirecta.vue"
      ),
  },
  {
    path: "/solicitudes-contratacion-directa/:id_solicitud/persona/:id_persona",
    name: "solicitud-contratacion-directa-completar-datos-persona",
    component: () =>
      import(
        /* webpackChunkName: "SolicitudContratacionDirecta" */ "./views/solicitud/component/contratacion-directa-v2/RegistrarEmpleado.vue"
      ),
  },
  {
    path: "/solicitudes-personas-declinadas",
    name: "solicitudes-personas-declinadas",
    component: () =>
      import(
        /* webpackChunkName: "SolicitudContratacionDirecta" */ "./views/solicitud/personas-declinadas/page/ListaPersonasDeclinadas.vue"
      ),
  },
];
